export default __webpack_public_path__ + "static/media/web_video_thumnail.91e4aa4a.jpg";